
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/lead-capture",
      function () {
        return require("private-next-pages/docs/lead-capture.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/lead-capture"])
      });
    }
  